import styled from 'styled-components';
import ColumnWrapper from '../../Column';

const Column = styled(ColumnWrapper)<{ $marginRight?: number }>`
    justify-content: center;
    margin-right: ${props => props.$marginRight}px;
`;

export default Column;
